import { render } from "./design-reference-process.vue?vue&type=template&id=5c3509fc&scoped=true"
import script from "./design-reference-process.vue?vue&type=script&lang=js"
export * from "./design-reference-process.vue?vue&type=script&lang=js"

import "./design-reference-process.vue?vue&type=style&index=0&id=5c3509fc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3509fc"]])

export default __exports__